import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductCardComponent } from '../product-card/product-card.component';
import { BaseWidget } from '../base-widget/base-widget';

@Component({
  selector: 'product-carousel',
  templateUrl: './product-carousel.component.html',
  styleUrl: './product-carousel.component.less',
  standalone: true,
  imports: [CommonModule, ProductCardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductCarouselComponent extends BaseWidget implements OnInit {
  @HostBinding('class') @Input() ngClass: any;
  @HostBinding('style') @Input() ngStyle: any;

  @Input() actionEvent: (event: any) => void;
  @Input() slot: any;
  @ViewChild('swiperMain', { static: false })
  swiper?: ElementRef<any>;
  // swiper?: ElementRef<SwiperContainer>;

  data: any;
  title: any;
  widgetAttributes: any;

  cssClassMap: Map<number, String> = new Map();
  cssStylesMap: Map<number, any> = new Map();

  ngOnInit() {}

  ngOnChanges() {
    this.data = this.slot?.widget?.data;
    this.title = this.slot?.widget?.header?.value?.titleValue;
    this.widgetAttributes = this.slot?.widget?.widgetAttributes;
    this.slot?.widget?.data?.renderableComponents?.forEach(
      (e: any, index: number) => {
        if (e.widgetAttributes) {
          this.cssClassMap.set(index, this.getClass(e.widgetAttributes));
          this.cssStylesMap.set(index, this.getStyles(e.widgetAttributes));
        }
      },
    );
  }

  onActionCall(actionData: any) {
    this.actionEvent(actionData);
  }
  slideNext() {
    this.swiper?.nativeElement?.swiper.slideNext(200);
  }
  slidePrev() {
    this.swiper?.nativeElement?.swiper.slidePrev(200);
  }

  @ViewChild('widgetsContent', { read: ElementRef })
  public widgetsContent: ElementRef<any>;

  public scrollRight(): void {
    this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft + 550,
      behavior: 'smooth',
    });
  }

  public scrollLeft(): void {
    this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft - 550,
      behavior: 'smooth',
    });
  }
}
